import type { UseCameraOptions, CameraEntityExtended } from "@hakit/core";

export function DummyComponentReturn(props: Partial<CameraEntityExtended>) {
  return props;
}

export function DummyComponentOptions(props: Partial<UseCameraOptions>) {
  return props;
}
